module.exports = __webpack_public_path__ + "static/icon-4-de6aee9084f4ea18f4a14d456bc2be4d.png";